module.exports = __webpack_public_path__ + "img/yw1.7eaaa688.png";